// extracted by mini-css-extract-plugin
module.exports = {"reports":"Standard_reports__C_YTM","card":"Standard_card__3B4fk","icon":"Standard_icon__1XsAv","cardContent":"Standard_cardContent__2-Uhe"};